var map = {
	"./": 81159,
	"./client": 62208,
	"./client/": 62208,
	"./client/actions": 15743,
	"./client/actions.ts": 15743,
	"./client/app-routes": 50790,
	"./client/app-routes.tsx": 50790,
	"./client/app-state": 69394,
	"./client/app-state.ts": 69394,
	"./client/assert-never": 89004,
	"./client/assert-never.ts": 89004,
	"./client/canvas": 62694,
	"./client/canvas.tsx": 62694,
	"./client/colors": 15170,
	"./client/colors.ts": 15170,
	"./client/comp/activity-content": 46365,
	"./client/comp/activity-content.tsx": 46365,
	"./client/comp/caret-down": 60995,
	"./client/comp/caret-down.ts": 60995,
	"./client/comp/caret-right": 13942,
	"./client/comp/caret-right.ts": 13942,
	"./client/comp/cat-filter": 77293,
	"./client/comp/cat-filter.tsx": 77293,
	"./client/comp/chart-content": 9019,
	"./client/comp/chart-content.tsx": 9019,
	"./client/comp/color-box": 70835,
	"./client/comp/color-box.ts": 70835,
	"./client/comp/const": 92425,
	"./client/comp/const.ts": 92425,
	"./client/comp/cookies-notification": 37340,
	"./client/comp/cookies-notification.tsx": 37340,
	"./client/comp/detail-level-select": 68148,
	"./client/comp/detail-level-select.tsx": 68148,
	"./client/comp/gas-select": 45920,
	"./client/comp/gas-select.tsx": 45920,
	"./client/comp/generic-chart": 91491,
	"./client/comp/generic-chart.tsx": 91491,
	"./client/comp/generic-filter": 86810,
	"./client/comp/generic-filter.tsx": 86810,
	"./client/comp/ghg-content": 65248,
	"./client/comp/ghg-content.tsx": 65248,
	"./client/comp/lang-select": 39020,
	"./client/comp/lang-select.tsx": 39020,
	"./client/comp/legend-item": 28941,
	"./client/comp/legend-item.ts": 28941,
	"./client/comp/main-chart": 29321,
	"./client/comp/main-chart.tsx": 29321,
	"./client/comp/markdown-content": 91154,
	"./client/comp/markdown-content.tsx": 91154,
	"./client/comp/measure-tab-bar": 35079,
	"./client/comp/measure-tab-bar.tsx": 35079,
	"./client/comp/pie-chart": 85835,
	"./client/comp/pie-chart-content": 48437,
	"./client/comp/pie-chart-content.tsx": 48437,
	"./client/comp/pie-chart.tsx": 85835,
	"./client/comp/sector-charts": 57758,
	"./client/comp/sector-charts.tsx": 57758,
	"./client/comp/sector-filter": 2073,
	"./client/comp/sector-filter.tsx": 2073,
	"./client/comp/segment-legend": 57617,
	"./client/comp/segment-legend.ts": 57617,
	"./client/comp/simple-legend": 14244,
	"./client/comp/simple-legend.tsx": 14244,
	"./client/comp/spinner": 5294,
	"./client/comp/spinner.tsx": 5294,
	"./client/comp/subcat-filter": 1806,
	"./client/comp/subcat-filter.tsx": 1806,
	"./client/comp/table-content": 87988,
	"./client/comp/table-content.tsx": 87988,
	"./client/comp/tooltip": 82768,
	"./client/comp/tooltip.ts": 82768,
	"./client/comp/totals-legend": 63434,
	"./client/comp/totals-legend.ts": 63434,
	"./client/comp/with-router": 24455,
	"./client/comp/with-router.tsx": 24455,
	"./client/comp/year-filter": 3302,
	"./client/comp/year-filter.tsx": 3302,
	"./client/comp/year-select": 44504,
	"./client/comp/year-select.tsx": 44504,
	"./client/connect": 48947,
	"./client/connect.tsx": 48947,
	"./client/context": 93671,
	"./client/context.ts": 93671,
	"./client/data": 19152,
	"./client/data.ts": 19152,
	"./client/data/dynamic-page-data": 46487,
	"./client/data/dynamic-page-data.ts": 46487,
	"./client/data/sectors": 121,
	"./client/data/sectors.ts": 121,
	"./client/data/simple-data": 27601,
	"./client/data/simple-data.ts": 27601,
	"./client/download-uri": 68279,
	"./client/download-uri.ts": 68279,
	"./client/dynamic-content-page": 59292,
	"./client/dynamic-content-page.tsx": 59292,
	"./client/export-png": 88116,
	"./client/export-png.ts": 88116,
	"./client/export-xlsx": 92629,
	"./client/export-xlsx.ts": 92629,
	"./client/footer": 21410,
	"./client/footer.tsx": 21410,
	"./client/geometry": 89395,
	"./client/geometry.ts": 89395,
	"./client/header": 60560,
	"./client/header.tsx": 60560,
	"./client/index": 62208,
	"./client/index.tsx": 62208,
	"./client/init-google-analytics": 76378,
	"./client/init-google-analytics.ts": 76378,
	"./client/layout": 2774,
	"./client/layout.tsx": 2774,
	"./client/localization-setup": 849,
	"./client/localization-setup.ts": 849,
	"./client/main": 39914,
	"./client/main.tsx": 39914,
	"./client/number-format": 5300,
	"./client/number-format.ts": 5300,
	"./client/reportWebVitals": 81139,
	"./client/reportWebVitals.ts": 81139,
	"./client/segments": 36934,
	"./client/segments.ts": 36934,
	"./client/setupTests": 72200,
	"./client/setupTests.ts": 72200,
	"./client/shared-utils": 34011,
	"./client/shared-utils.ts": 34011,
	"./client/styles/all.sass": 13841,
	"./client/styles/colors.sass": 53897,
	"./client/totals": 49040,
	"./client/totals.ts": 49040,
	"./client/types": 16856,
	"./client/types.ts": 16856,
	"./data/detail": 35616,
	"./data/detail/": 35616,
	"./data/detail/agri/i_cereal.yml": 22034,
	"./data/detail/agri/i_fert.yml": 75885,
	"./data/detail/agri/i_histosol.yml": 85413,
	"./data/detail/agri/i_livestock.md": 77651,
	"./data/detail/agri/i_livestock_1.yml": 19374,
	"./data/detail/agri/i_livestock_2.yml": 24163,
	"./data/detail/agri/i_livestock_et.md": 40624,
	"./data/detail/agri/i_manure.md": 3539,
	"./data/detail/agri/i_manure_1.yml": 22102,
	"./data/detail/agri/i_manure_2.yml": 28088,
	"./data/detail/agri/i_manure_3.yml": 32603,
	"./data/detail/agri/i_manure_4.yml": 5008,
	"./data/detail/agri/i_manure_et.md": 80309,
	"./data/detail/agri/i_milk.yml": 61185,
	"./data/detail/agri/inventory_0.md": 47885,
	"./data/detail/agri/inventory_0_et.md": 43682,
	"./data/detail/agri/p_cereal.yml": 48053,
	"./data/detail/agri/p_fert.yml": 49398,
	"./data/detail/agri/p_histosol.yml": 4377,
	"./data/detail/agri/p_livestock.yml": 31893,
	"./data/detail/agri/p_manure.yml": 5865,
	"./data/detail/agri/p_methodology.md": 74325,
	"./data/detail/agri/p_methodology_et.md": 26792,
	"./data/detail/agri/p_milk.yml": 68396,
	"./data/detail/agri/prognosis_0.md": 4044,
	"./data/detail/agri/prognosis_0_et.md": 21794,
	"./data/detail/energy/i_energy_cons.md": 99264,
	"./data/detail/energy/i_energy_cons_1.yml": 41810,
	"./data/detail/energy/i_energy_cons_2.yml": 2637,
	"./data/detail/energy/i_energy_cons_3.yml": 11986,
	"./data/detail/energy/i_energy_cons_4.yml": 2256,
	"./data/detail/energy/i_energy_cons_5.yml": 25770,
	"./data/detail/energy/i_energy_cons_6.yml": 47529,
	"./data/detail/energy/i_energy_cons_7.yml": 24319,
	"./data/detail/energy/i_energy_cons_et.md": 32253,
	"./data/detail/energy/i_oil_shale.yml": 19556,
	"./data/detail/energy/i_wind_solar_hydro.yml": 62339,
	"./data/detail/energy/inv_intro.md": 96240,
	"./data/detail/energy/inv_intro_et.md": 84018,
	"./data/detail/energy/p_energy_cons.md": 54835,
	"./data/detail/energy/p_energy_cons_1.yml": 50216,
	"./data/detail/energy/p_energy_cons_et.md": 65743,
	"./data/detail/energy/p_energy_fuel.md": 17388,
	"./data/detail/energy/p_energy_fuel_1.yml": 59509,
	"./data/detail/energy/p_methodology.md": 87084,
	"./data/detail/energy/p_methodology_et.md": 57605,
	"./data/detail/energy/p_oil_shale.yml": 20533,
	"./data/detail/energy/p_wind_solar_hydro.md": 20656,
	"./data/detail/energy/p_wind_solar_hydro_1.yml": 66667,
	"./data/detail/energy/p_wind_solar_hydro_et.md": 73799,
	"./data/detail/energy/prognosis_0.md": 8831,
	"./data/detail/energy/prognosis_0_et.md": 85999,
	"./data/detail/ets_esr/i_ets_esr.yml": 5351,
	"./data/detail/ets_esr/p_esr_sectoral.yml": 78787,
	"./data/detail/ets_esr/p_ets_esr_sectoral.md": 97714,
	"./data/detail/ets_esr/p_ets_esr_sectoral_et.md": 5159,
	"./data/detail/ets_esr/p_ets_esr_total.yml": 94963,
	"./data/detail/ets_esr/p_ets_sectoral.yml": 70805,
	"./data/detail/index": 35616,
	"./data/detail/index.json": 35616,
	"./data/detail/introduction/i_introduction.md": 97752,
	"./data/detail/introduction/i_introduction_et.md": 16111,
	"./data/detail/introduction/p_introduction.md": 44968,
	"./data/detail/introduction/p_introduction_et.md": 68392,
	"./data/detail/ippu/i_SF6.yml": 27844,
	"./data/detail/ippu/i_industry.md": 88594,
	"./data/detail/ippu/i_industry_et.md": 19613,
	"./data/detail/ippu/i_ippu_fuel.yml": 63435,
	"./data/detail/ippu/i_medical.yml": 19002,
	"./data/detail/ippu/i_refigeration.yml": 20781,
	"./data/detail/ippu/inv_intro.md": 42416,
	"./data/detail/ippu/inv_intro_et.md": 16444,
	"./data/detail/ippu/p_SF6.yml": 65822,
	"./data/detail/ippu/p_industry.md": 51121,
	"./data/detail/ippu/p_industry_et.md": 95066,
	"./data/detail/ippu/p_ippu_fuel.md": 81055,
	"./data/detail/ippu/p_ippu_fuel_1.yml": 12817,
	"./data/detail/ippu/p_ippu_fuel_2.yml": 93286,
	"./data/detail/ippu/p_medical.yml": 94406,
	"./data/detail/ippu/p_methodology.md": 27118,
	"./data/detail/ippu/p_methodology_et.md": 65362,
	"./data/detail/ippu/p_refigeration.yml": 37705,
	"./data/detail/ippu/prognosis_0.md": 16307,
	"./data/detail/ippu/prognosis_0_et.md": 99465,
	"./data/detail/lulucf/i_biomass.md": 18173,
	"./data/detail/lulucf/i_biomass_1.yml": 57761,
	"./data/detail/lulucf/i_biomass_2.yml": 60449,
	"./data/detail/lulucf/i_biomass_et.md": 97042,
	"./data/detail/lulucf/i_change_matrix.yml": 32360,
	"./data/detail/lulucf/i_hwp.md": 39539,
	"./data/detail/lulucf/i_hwp_1.yml": 49793,
	"./data/detail/lulucf/i_hwp_2.yml": 91227,
	"./data/detail/lulucf/i_hwp_et.md": 81727,
	"./data/detail/lulucf/i_land.md": 45413,
	"./data/detail/lulucf/i_land_1.yml": 54498,
	"./data/detail/lulucf/i_land_2.yml": 60827,
	"./data/detail/lulucf/i_land_3.yml": 87974,
	"./data/detail/lulucf/i_land_4.yml": 40701,
	"./data/detail/lulucf/i_land_5.yml": 60039,
	"./data/detail/lulucf/i_land_6.yml": 98654,
	"./data/detail/lulucf/i_land_et.md": 55878,
	"./data/detail/lulucf/i_lu_aggregation.yml": 4171,
	"./data/detail/lulucf/i_wetland.md": 2320,
	"./data/detail/lulucf/i_wetland_1.yml": 70421,
	"./data/detail/lulucf/i_wetland_2.yml": 24258,
	"./data/detail/lulucf/i_wetland_et.md": 79771,
	"./data/detail/lulucf/inv_intro.md": 97175,
	"./data/detail/lulucf/inv_intro_et.md": 85799,
	"./data/detail/lulucf/p_biomass.yml": 3589,
	"./data/detail/lulucf/p_hwp.md": 49792,
	"./data/detail/lulucf/p_hwp_1.yml": 57788,
	"./data/detail/lulucf/p_hwp_2.yml": 11034,
	"./data/detail/lulucf/p_hwp_3.yml": 94368,
	"./data/detail/lulucf/p_land.yml": 37361,
	"./data/detail/lulucf/p_methodology.md": 34688,
	"./data/detail/lulucf/p_methodology_et.md": 8172,
	"./data/detail/lulucf/p_wetland.md": 24608,
	"./data/detail/lulucf/p_wetland_1.yml": 98874,
	"./data/detail/lulucf/p_wetland_2.yml": 79605,
	"./data/detail/lulucf/prognosis_0.md": 1037,
	"./data/detail/lulucf/prognosis_0_et.md": 61965,
	"./data/detail/transport/i_bunkering.yml": 92147,
	"./data/detail/transport/i_trans.md": 18626,
	"./data/detail/transport/i_trans_1.yml": 22719,
	"./data/detail/transport/i_trans_2.yml": 48404,
	"./data/detail/transport/i_trans_et.md": 14463,
	"./data/detail/transport/i_trans_fuel.yml": 91620,
	"./data/detail/transport/inv_intro.md": 11716,
	"./data/detail/transport/inv_intro_et.md": 53821,
	"./data/detail/transport/p_bunkering.yml": 75405,
	"./data/detail/transport/p_methodology.md": 14237,
	"./data/detail/transport/p_methodology_et.md": 60598,
	"./data/detail/transport/p_trans.md": 95085,
	"./data/detail/transport/p_trans_1.yml": 169,
	"./data/detail/transport/p_trans_et.md": 40591,
	"./data/detail/transport/p_trans_fuel.md": 87359,
	"./data/detail/transport/p_trans_fuel_1.yml": 36851,
	"./data/detail/transport/prognosis_0.md": 82775,
	"./data/detail/transport/prognosis_0_et.md": 2507,
	"./data/detail/waste/i_bio.yml": 38780,
	"./data/detail/waste/i_burn.yml": 40462,
	"./data/detail/waste/i_composition.yml": 42542,
	"./data/detail/waste/i_msw.yml": 41461,
	"./data/detail/waste/i_water.md": 54317,
	"./data/detail/waste/i_water_1.yml": 15669,
	"./data/detail/waste/i_water_2.yml": 78957,
	"./data/detail/waste/i_water_et.md": 57112,
	"./data/detail/waste/inventory_0.md": 33883,
	"./data/detail/waste/inventory_0_et.md": 32695,
	"./data/detail/waste/p_bio.yml": 20910,
	"./data/detail/waste/p_biogas.yml": 12235,
	"./data/detail/waste/p_burn.md": 35083,
	"./data/detail/waste/p_burn_1.yml": 8220,
	"./data/detail/waste/p_burn_2.yml": 28985,
	"./data/detail/waste/p_burn_3.yml": 59300,
	"./data/detail/waste/p_burn_et.md": 71299,
	"./data/detail/waste/p_methodology.md": 46429,
	"./data/detail/waste/p_methodology_et.md": 30983,
	"./data/detail/waste/p_msw.yml": 73834,
	"./data/detail/waste/p_water.yml": 26266,
	"./data/detail/waste/prognosis_0.md": 46607,
	"./data/detail/waste/prognosis_0_et.md": 9247,
	"./data/economic-indicators-ghg": 38369,
	"./data/economic-indicators-ghg/": 38369,
	"./data/economic-indicators-ghg/GHG_GDP_1.md": 20622,
	"./data/economic-indicators-ghg/GHG_GDP_1_et.md": 78398,
	"./data/economic-indicators-ghg/index": 38369,
	"./data/economic-indicators-ghg/index.json": 38369,
	"./data/emission-factors": 66843,
	"./data/emission-factors/": 66843,
	"./data/emission-factors/i_electricity.yml": 19290,
	"./data/emission-factors/i_heat.yml": 17836,
	"./data/emission-factors/i_lulucf.yml": 73858,
	"./data/emission-factors/index": 66843,
	"./data/emission-factors/index.json": 66843,
	"./data/emission-factors/p_electricity.yml": 8262,
	"./data/emission-factors/p_heat.yml": 73752,
	"./data/past/ch4.yml": 41222,
	"./data/past/co2.yml": 80907,
	"./data/past/co2eq.yml": 12778,
	"./data/past/hfc.yml": 63582,
	"./data/past/n2o.yml": 98317,
	"./data/past/pfc.yml": 53664,
	"./data/past/proportion.yml": 32633,
	"./data/past/sf6.yml": 83840,
	"./data/prognosis/wam/ch4.yml": 39282,
	"./data/prognosis/wam/co2.yml": 4745,
	"./data/prognosis/wam/co2eq.yml": 38520,
	"./data/prognosis/wam/hfc.yml": 71891,
	"./data/prognosis/wam/n2o.yml": 45353,
	"./data/prognosis/wam/sf6.yml": 48699,
	"./data/prognosis/wem/ch4.yml": 33039,
	"./data/prognosis/wem/co2.yml": 1488,
	"./data/prognosis/wem/co2eq.yml": 82860,
	"./data/prognosis/wem/hfc.yml": 46841,
	"./data/prognosis/wem/n2o.yml": 85214,
	"./data/prognosis/wem/sf6.yml": 10364,
	"./data/projects": 39071,
	"./data/projects/": 39071,
	"./data/projects/agriculture/ag_1.md": 22139,
	"./data/projects/agriculture/ag_1_et.md": 86441,
	"./data/projects/agriculture/ag_2.md": 23491,
	"./data/projects/agriculture/ag_2_et.md": 8408,
	"./data/projects/agriculture/ag_3.md": 42504,
	"./data/projects/agriculture/ag_3_et.md": 19988,
	"./data/projects/agriculture/ag_4.md": 33085,
	"./data/projects/agriculture/ag_4_et.md": 49651,
	"./data/projects/energy.md": 82939,
	"./data/projects/energy/en_1.md": 77002,
	"./data/projects/energy/en_1_et.md": 1932,
	"./data/projects/energy/en_2.md": 21005,
	"./data/projects/energy/en_2_et.md": 99777,
	"./data/projects/energy/en_3.md": 24736,
	"./data/projects/energy/en_3_et.md": 68039,
	"./data/projects/index": 39071,
	"./data/projects/index.json": 39071,
	"./data/projects/ippu/ip_1.md": 87822,
	"./data/projects/ippu/ip_1_et.md": 71828,
	"./data/projects/lulucf/lu_1.md": 32498,
	"./data/projects/lulucf/lu_1_et.md": 4795,
	"./data/projects/overview/intro.md": 81925,
	"./data/projects/overview/intro_et.md": 54663,
	"./data/projects/project2 copy.md": 24536,
	"./data/projects/project2.md": 27383,
	"./data/projects/transport/tr_1.md": 94556,
	"./data/projects/transport/tr_1_et.md": 259,
	"./data/projects/waste/wa_1.md": 34301,
	"./data/projects/waste/wa_1_et.md": 99534,
	"./details-types.d": 35390,
	"./details-types.d.ts": 35390,
	"./index": 81159,
	"./index.ts": 81159,
	"./locales/en.yml": 42793,
	"./locales/en_old.yml": 10158,
	"./locales/et.yml": 17276,
	"./locales/et_old.yml": 48791,
	"./locales/ru.yml": 13552,
	"./locales/ru_old.yml": 87161,
	"./react-app-env.d": 44398,
	"./react-app-env.d.ts": 44398
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 18116;